var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartPiece(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 41,
    viewBox: "0 0 34 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.641 12.501C28.469 12.501 27.2557 15.861 27.75 18.3576L22.4324 26.6643C21.983 26.4543 21.3239 26.4543 20.8746 26.6643L17.0549 20.7143C17.5642 18.2176 16.3508 14.8343 14.1639 14.8343C11.9919 14.8343 10.7636 18.1943 11.2729 20.7143L4.44239 31.331C2.83962 30.561 0.682617 32.451 0.682617 35.8343C0.682617 38.401 2.03074 40.501 3.67845 40.501C5.85043 40.501 7.06375 37.141 6.56943 34.6443L13.385 24.0043C13.8343 24.2143 14.4934 24.2143 14.9428 24.0043L18.7625 29.9543C18.2532 32.451 19.4665 35.8343 21.6535 35.8343C23.8255 35.8343 25.0537 32.4743 24.5445 29.9543L29.877 21.671C31.4798 22.441 33.6368 20.551 33.6368 17.1676C33.6368 14.601 32.2887 12.501 30.641 12.501Z",
    fill: "#808795"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6535 14.834L23.0615 10.004L26.1472 7.83398L23.0615 5.66398L21.6535 0.833984L20.2754 5.66398L17.1597 7.83398L20.2754 10.004L21.6535 14.834ZM4.42741 19.5007L5.17637 14.834L8.17221 13.6673L5.17637 12.5007L4.42741 7.83398L3.67845 12.5007L0.682617 13.6673L3.67845 14.834L4.42741 19.5007Z",
    fill: "#808795"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartPiece);
export default __webpack_public_path__ + "static/media/ChartPiece.87354cf97ad04d410cf7ec90b3a340ae.svg";
export { ForwardRef as ReactComponent };